import { RouteConfig } from 'vue-router';
import { RouteRoles } from '@/router/role-routes';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { Staffs } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Staffs.Pages.STAFFS}`,
    name: Staffs.Pages.STAFFS,
    component: () => import(/* webpackChunkName: "staffs" */ './views/Staffs.vue'),
    meta: {
      access_roles: RouteRoles[Staffs.Pages.STAFFS],
    },
  },
  {
    path: `/${Staffs.Pages.STAFF_DETAIL}/:id`,
    name: Staffs.Pages.STAFF_DETAIL,
    component: () => import(/* webpackChunkName: "staff" */ './views/StaffDetail.vue'),
    meta: {
      access_roles: RouteRoles[Staffs.Pages.STAFF_DETAIL],
    },
  },
  {
    path: `/${Staffs.Pages.STAFF_DETAIL}/:id/edit`,
    name: Staffs.Pages.STAFF_EDIT,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "staff-edit" */ './views/StaffEdit.vue'),
    meta: {
      access_roles: RouteRoles[Staffs.Pages.STAFF_EDIT],
    },
  },
  {
    path: `/${Staffs.Pages.STAFF_CERTIFICATES}`,
    name: Staffs.Pages.STAFF_CERTIFICATES,
    component: () => import(/* webpackChunkName: "staff-certificates" */ './views/StaffCertificates.vue'),
    meta: {
      access_roles: RouteRoles[Staffs.Pages.STAFF_CERTIFICATES],
    },
  },
];

export default routes;
